import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Routes from './Routes';
import NoticePopup from '@components/NoticePopup';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const mapDispatch = (dispatch) => ({
  getLoggedUser: dispatch.user.getLoggedUser,
  getDisclaimers: dispatch.user.getDisclaimers,
  getMenu: dispatch.menu.getMenu,
  fetchUnreadNotices: dispatch.notice.fetchUnreadNotices,
});

class App extends React.Component {
  static propTypes = {
    getLoggedUser: PropTypes.func.isRequired,
    getMenu: PropTypes.func.isRequired,
    getDisclaimers: PropTypes.func.isRequired,
    fetchUnreadNotices: PropTypes.func.isRequired,
  };
  init = async () => {
    const { getLoggedUser, getMenu, getDisclaimers, fetchUnreadNotices } =
      this.props;
    try {
      await getLoggedUser();
      await getMenu();
      await getDisclaimers();
      await fetchUnreadNotices();
    } catch (error) {}
  };
  componentDidMount() {
    this.init();
  }
  render() {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <NoticePopup />
        <Routes />
      </BrowserRouter>
    );
  }
}

export default connect(null, mapDispatch)(App);
